import { naiveSlugify } from './testIds';

import { getEnvironment } from '../config';

export { TEST_ID, naiveSlugify } from './testIds';

/**
 * Joins the provided strings with a hyphen and returns the result. Includes
 * basic transforms; trim whitespace, convert to lowercase, etc.
 *
 * @returns The joined strings, **unless** in production environment.
 */
export function makeTestId(...args: string[]) {
  const env = getEnvironment();
  if (env === 'prod') {
    return undefined;
  }

  return args.map(naiveSlugify).join('-');
}
